define([
    "jquery",
    "underscore",
    "marionette",
    "datatables"
], function($, _, Marionette) {
    return Marionette.Behavior.extend({

        ui:{
            'datatables': '#datatables',
            'filters': '.filter',
            'filterBtn': '#filter_btn'
        },

        events:{
            'click @ui.filterBtn': function(e){
                if(e) e.preventDefault();

                // Reload the table on page 1
                this.triggerMethod('reload:table');
            }
        },

        initialize: function(){
        },

        onReloadTable: function(){
            this.datatables.ajax.reload();

            // Its useful sometimes to know in the view
            // when the datable has been reloaded
            this.view.triggerMethod('datatable:reloaded');
        },

        _prepareData: function(d){
            this.ui.filters.each(function(index, item){
                d[$(this).attr("name")] = $(this).val();
            });
            d.length = d.length > -1 ? d.length : 5;
        },

        onInitTable: function(config){
            config = config || {};
            Object.assign(config, {
                language: {
                    url: baseUrl+'/assets/common/common/js/libs/DataTables/languages/'+lang+'.json',
                    paginate: {
                        previous: '<',
                        next: '>'
                    }
                }
            })

            var that = this;

            this.datatables = this.ui.datatables.DataTable(_.extend({
                'searching': false,
                'ordering': true,
                'stateSave': false,
                'columns':[

                ],
                "createdRow": function( row, data, dataIndex ){

                },
                'deferRender': true,
                'serverSide': true, // Use server side handling
                'pageLength': 10, // nbPerPage,
                'processing': true,
                'ajax': {
                    type: "POST", // URLs are too long, so let's use POST
                    url: baseUrl + config.url,
                    data: function(d){
                        that._prepareData(d);
                    }
                },
                'drawCallback': function(settings) {
                    $('#datatables').parent().addClass('table-responsive');
                }
            }, config));
        }
    });
});
